import "./app.scss";
import ServiceForm from "./components/ServiceForm";
import desktop from "./assets/images/desktop.png";
import mobile from "./assets/images/mobile.png";
import "./assets/scss/cconsent-bar.css";
function App() {
    return (
        <>
            <div className="popup-container">
                <div className="main-image">
                    <img src={desktop} className="background-image" alt=""/>
                    <img src={mobile} className="background-image-mobile" alt=""/>
                </div>
                
                <div className="form-bg">
                    <ServiceForm/>
                </div>
            </div>
        </>
    );
}

export default App;
